import { ShipmentOrderResponseEntity } from 'src/entities/ShipmentOrderResponse.entity';

export type LaneShipperRow = {
  shipperName: string;
  /** 「担当: ◯◯ / TEL: ×××」。引けない側は落とす */
  contactText: string;
};

/**
 * レーン詳細の荷主情報。伝票ごとではなく荷主ごとにまとめる。
 *
 * 伝票 1 件につき 1 カードを縦に積んでいたため、同じ荷主が伝票の数だけ並び、
 * 画面 1 枚分の幅と高さを取っていた（報告のスクリーンショットでは同一荷主が 3 回）。
 *
 * 同名でも担当者・連絡先が違えば別の相手なので、まとめずに分ける
 * （まとめると片方の連絡先が消える）。
 */
export function buildLaneShippers(
  orders: readonly ShipmentOrderResponseEntity[],
): LaneShipperRow[] {
  const byKey = new Map<string, LaneShipperRow>();

  orders.forEach((order) => {
    const contact = order.shipperContactPerson?.trim() ?? '';
    const phone = order.shipperPhoneNumber?.trim() ?? '';
    const key = `${order.shipperName} ${contact} ${phone}`;
    if (byKey.has(key)) return;

    const parts: string[] = [];
    if (contact) parts.push(`担当: ${contact}`);
    if (phone) parts.push(`TEL: ${phone}`);

    byKey.set(key, { shipperName: order.shipperName, contactText: parts.join(' / ') });
  });

  return [...byKey.values()];
}
